<div *ngIf="hasPhotos" class="activity-photo-thumbs">
  <span class="activity-photo-thumbs__label">Fotky:</span>
  <div class="activity-photo-thumbs__grid">
    <button
      *ngFor="let photo of resolved"
      type="button"
      class="activity-photo-thumbs__thumb"
      (click)="open(photo, $event)"
      [attr.aria-label]="photo.description || 'Zvětšit fotku'"
    >
      <img
        [src]="photo.url"
        [alt]="photo.description || 'Foto'"
        class="activity-photo-thumbs__img"
        (error)="onImageError($event)"
      />
    </button>
  </div>
</div>

<app-modal
  [isOpen]="!!selected"
  title="Foto"
  [showFooter]="false"
  width="56rem"
  maxWidth="92vw"
  (closeEvent)="close()"
>
  <div *ngIf="selected" class="flex flex-col items-center justify-center gap-2">
    <app-zoomable-photo
      [src]="selected.url"
      [alt]="selected.description || 'Foto'"
    ></app-zoomable-photo>
    <p *ngIf="selected.description" class="text-sm text-neutral-700 dark:text-neutral-300 text-center m-0">
      {{ selected.description }}
    </p>
  </div>
</app-modal>
